import { initialProps } from '@utils/initial'
import { routes } from '@group-devs/yfp7-global-modules/data/lcw'

import Error from '../404'
import Head from 'next/head'
import { Discover, IndexHeaderDiscover, WhatToShowDiscover, HelpMe } from '@components/Block'


export async function getServerSideProps({req, res, query}) {
    return {
        props: await initialProps(req, res, query, routes.ds)
    }
}

const DiscoverIndex = (props) => {

    if (typeof props.err !== "undefined")
        return <Error statusCode={props.err.code} />

    return (
        <Discover global={props}>
            <Head><title>Explore Wellness</title></Head>
            <IndexHeaderDiscover site={props} />
            <WhatToShowDiscover/>
            <HelpMe site={props.site}/>
        </Discover>
    )
}

export default DiscoverIndex